<template>
  <div>
    <Breadcrumbs main="Acente" title="Kontrol Paneli" />

    <div class="container-fluid">
      <div class="row" v-if="profilDurumu !== ''">
        <div class="col-xl-12">
          <b-alert show variant="danger">
            <h4 class="alert-heading">Profil Durumunuz</h4>
            <p>
              Profilinizde bazı eksiklikler bulduk. Bunları doldurduğunuzda
              rezervasyon işlemlerinizi kolaylaştıracaktır.
            </p>
            <hr />
            <p v-html="profilDurumu" class="mb-3"></p>
            <p>
              <router-link to="/acente/profil" class="btn btn-dark">Güncelle</router-link>
              Profil sayfanızdan giriş yapıp Düzelt butonuna basarak gerekli
              güncellemeleri yapabilirsiniz.
            </p>
          </b-alert>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <ul class="nav nav-tabs border-tab tabs-scoial" id="top-tab" role="tablist">
            <li class="nav-item" v-on:click="changetab('rezervasyon')">
              <a class="nav-link" :class="[
        { 'show active': showtab == 'rezervasyon' },
        'shadow-lg p-25 shadow-showcase',
      ]" id="top-rezervasyon" data-toggle="tab" role="tab" aria-controls="rezervasyon" aria-selected="true">PRIVATE TUR REZERVASYONU</a>
            </li>
            <li class="nav-item" v-on:click="changetab('regularrezervasyon')">
              <a class="nav-link" :class="[
        { 'show active': showtab == 'regularrezervasyon' },
        'shadow-lg p-25 shadow-showcase',
      ]" id="top-regular-rezervasyon" data-toggle="tab" role="tab" aria-controls="regularrezervasyon" aria-selected="true">REGULAR TUR REZERVASYONU</a>
            </li>
            <li class="nav-item" v-on:click="changetab('dashboard')">
              <a class="nav-link" :class="[
        { 'show active': showtab == 'dashboard' },
        'shadow-lg p-25 shadow-showcase',
      ]" id="top-dashboard" data-toggle="tab" role="tab" aria-controls="dashboard" aria-selected="false">Kontrol Paneli
                <b-badge variant="primary">Önümüzdeki 7 Gün {{ turRezervasyonSayi }} Rezervasyon
                  Var</b-badge></a>
            </li>
          </ul>
        </div>
      </div>

      <div class="tab-content" id="top-tabContent">
        <div class="tab-pane fade" :class="{ 'show active': showtab == 'rezervasyon' }" id="rezervasyon" role="tabpanel"
          aria-labelledby="rezervasyon">
          <TurRezervasyonForm @onComplete="onComplete" :acenteId="acenteId"></TurRezervasyonForm>
        </div>

        <div class="tab-pane fade" :class="{ 'show active': showtab == 'regularrezervasyon' }" id="regular-rezervasyon" role="tabpanel"
          aria-labelledby="regularrezervasyon">

          <b-alert show variant="info" class="alert dark">
              <p>Regular Tur Sekmesi 15 Nisan itibariyle aktif olacaktır.<br> Anlayışınız için teşekkür ederiz.</p>
            </b-alert>
          <!--<RegularRezervasyonForm @onComplete="onCompleteRegular" :acenteId="acenteId"></RegularRezervasyonForm>-->
        </div>

        <div class="tab-pane fade" :class="{ 'show active': showtab == 'dashboard' }" id="dashboard" role="tabpanel"
          aria-labelledby="dashboard">
          <div class="row">
            <div class="col-xl-12">
              <TurRezervasyonList />
            </div>
          </div>
        </div>
      </div>
    </div>

    <DuyuruGosterimModal />
  </div>
</template>
<script>
import TurRezervasyonForm from "@/components/c_tur_rezervasyon_form.vue";
import RegularRezervasyonForm from "@/components/c_regular_rezervasyon_form.vue";
import TurRezervasyonList from "@/components/c_tur_rezervasyon_dashboard_acente.vue";
import DuyuruGosterimModal from "@/components/c_duyuru_gosterim";

export default {
  data() {
    return {
      acenteId: 0,
      
      showtab: "rezervasyon",

      turRezervasyonSayi: 0,

      profilDurumu: "",
    };
  },
  components: {
    TurRezervasyonForm,
    RegularRezervasyonForm,
    TurRezervasyonList,
    DuyuruGosterimModal,
  },
  mounted() {
    let user = this.$user.getUser();
    this.acenteId = user.Kullanici.AcenteId;
    this.turRezervasyonSayiLoad();
    this.profilDurumLoad();
  },
  methods: {
    changetab(tab) {
      this.showtab = tab;
    },
    onComplete(kayit) {
      let vm = this;

      let url = "/turRezervasyonlari/" + this.acenteId;
      let method = "post";
      let messageTitle = "Yeni Rezervasyon";

      vm.$connection.post(
        url,
        kayit,
        method,
        function (response) {
          if (response.Success) {
            vm.$alert.messageWithFunction(
              messageTitle,
              response.Message,
              "success",
              function () {
                vm.$router.push("/turRezervasyon/detay/" + response.Data);
              }
            );
          }
        },
        function (error) {
          vm.$alert.messageWithTitle(messageTitle, error.Message, "error");
        }
      );
    },
    onCompleteRegular(kayit) {
      let vm = this;

      let url = "/regularRezervasyonlar/istek/" + this.acenteId;
      let method = "post";
      let messageTitle = "Yeni Regular Rezervasyon";

      vm.$connection.post(
        url,
        kayit,
        method,
        function (response) {
          if (response.Success) {
            vm.$alert.messageWithFunction(
              messageTitle,
              response.Message,
              "success",
              function () {
                vm.$router.push("/regularRezervasyon/istekDetay/" + response.Data);
              }
            );
          }
        },
        function (error) {
          vm.$alert.messageWithTitle(messageTitle, error.Message, "error");
        }
      );
    },
    turRezervasyonSayiLoad() {
      let vm = this;

      this.$connection.get(
        "/turRezervasyonlari/sayiForAcente",
        function (response) {
          vm.turRezervasyonSayi = response;
        }
      );
    },
    profilDurumLoad() {
      let vm = this;
      this.$connection.get("/acenteler/profilDurum", function (response) {
        vm.profilDurumu = response;
      });
    },
  },
};
</script>
